import {COOKIE_TYPE} from './cookieType';

/**
 * Sends custom tracking event of the form:
 *
 * dataLayer.push({
 *  "event": "set_cookie_consent",
 *  "tracking": "" // either "granted", or "denied", depending on the user choice in the "Performance" consent toggle
 *  "advertising": "" // either "granted", or "denied", depending on the user choice in the "Marketing" consent toggle
 *});
 *
 * @param {object} track track object that contains tracking functions
 * @param {object} values the cookies values
 */
export const cookieConsent = (track, values) => {
  track.custom_event({
    event: 'set_cookie_consent',
    tracking: values?.[COOKIE_TYPE.PERFORMANCE] ? 'granted' : 'denied',
    advertising: values?.[COOKIE_TYPE.MARKETING] ? 'granted' : 'denied',
  });
};
